import { useCallback, useEffect, useState } from 'react';
import { edmCampaign } from '@bingads-webui/edm-campaign';

function useAccountPropertyRepository({ cid, aid }) {
  const [enableDoubleVerifyForAllCampaigns, setEnableDoubleVerifyForAllCampaigns] = useState(false);
  const [doubleVerifyLinkEstablished, setDoubleVerifyLinkEstablished] = useState(false);

  const readAccount = useCallback(() => edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .get({ select: ['EnableDoubleVerifyForAllCampaigns,DoubleVerifyLinkEstablished'] })
    .toPromise(), [aid, cid]);

  useEffect(() => {
    readAccount().then((account) => {
      setEnableDoubleVerifyForAllCampaigns(account.EnableDoubleVerifyForAllCampaigns === 'true');
      setDoubleVerifyLinkEstablished(account.DoubleVerifyLinkEstablished === '1');
    }).catch((e) => {
      throw e;
    });
  }, [readAccount]);

  return [doubleVerifyLinkEstablished, enableDoubleVerifyForAllCampaigns];
}

export { useAccountPropertyRepository };
